import { LogGroup, Log } from ".././MyHelpers";
import {  } from "../version";
import { Resource } from "./Resource";

export class FontResource extends Resource
{
	get Name(): string {
		return this.name;
	}

	get Type(): string {
		return "font"
	}
	
	private parent: HTMLElement = null;
	private cssElem: HTMLElement = null;


	private fontFace: FontFace = null;
	
	private static logGroup: LogGroup = new LogGroup("FontResource");

	public constructor(path: string, name: string = null, /*fontFamily: string, */parent: HTMLElement = null, required: boolean = true) {
		super(path, name, required);
		this.fontFace = new FontFace(name, "url(\"" + path + "\")");
	}

	public Load(preventCache: boolean = false): void {
		this.fontFace.load()
			.then(() => {
				//// Log.Debug(FontResource.logGroup, "Font loaded successfully: " + this.path);
				// if (this.name == "Screen1-Multigame-LavaLandMysticWarriorsFillingPot-FreeGameBonus-bigwincount") debugger;

				document.fonts.add(this.fontFace);
				this.Loaded();
			})
			.catch((reason) => {
				Log.Error(FontResource.logGroup, "Font load error: ", this.path, reason);

				this.LoadError();
			});
	}

	public override Reload(preventCache: boolean = false): void {
		this.Load(preventCache);
	}
}